export enum EPrepareStatus {
  NEW = "N",
  IN_PROGRESS = "I",
  COMPLETE = "C",
}
